module.exports = __webpack_public_path__ + "static/img/skin-footer.ab288806.png";